import { useContext } from "react"
import { LocaleContext } from "contexts"
import cc from "classcat"
import H2 from "components/atoms/H2"
import useTranslations from "hooks/useTranslations"
import SectionContainer from "components/molecules/common/SectionContainer"
import { logosByLocale, customLogosByPage } from "./logos"

const LogCell = ({ logo, className }) => {
  return (
    <div className={cc(["flex items-center p-8", className])}>
      <logo.image
        key={logo.name}
        loading="lazy"
        className={cc([
          "mx-auto flex aspect-square h-full w-full first:pl-0 last:pr-0 md:px-0",
          logo.className,
        ])}
      />
    </div>
  )
}

const LogoGrid = ({
  center = false,
  currentPage,
  title = "",
  className = "",
  cellClassName = "bg-gray-400/5",
}) => {
  const { locale } = useContext(LocaleContext)
  const { ourCustomers } = useTranslations()
  const logos =
    customLogosByPage?.[currentPage]?.[locale] || logosByLocale[locale]

  return (
    <SectionContainer className={cc(["text-zinc-800", className])}>
      <div
        className={cc([
          "mx-auto mb-8 max-w-7xl px-4 sm:px-6 lg:mb-16 lg:px-8",
          center ? "text-center" : "",
        ])}
      >
        <H2 textAlign="center">{title || ourCustomers}</H2>
      </div>
      <div
        className={cc([
          "space-y-2 sm:px-0 md:gap-x-6 lg:w-full",
          center ? "mx-auto md:justify-center" : "",
        ])}
      >
        <div
          className={cc([
            "-mx-6 grid grid-cols-2 gap-0.5 overflow-hidden sm:mx-0 sm:rounded-2xl",
            logos.length % 3 === 0 ? "sm:grid-cols-3" : "sm:grid-cols-4",
          ])}
        >
          {logos.map((logo) => (
            <LogCell logo={logo} key={logo.name} className={cellClassName} />
          ))}
        </div>
      </div>
    </SectionContainer>
  )
}

export default LogoGrid
